import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class AdReadonlySerivce {
  _readonly: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  _readOnly$: Observable<boolean> = this._readonly.asObservable();

  get readonly$() {
    return this._readOnly$;
  }

  get isReadonly() {
    return this._readonly.getValue();
  }

  setReadonly(toReadOnly: boolean) {
    this._readonly.next(toReadOnly);
  }
}